import { ForgotPasswordForm, ResetPasswordForm } from "../components/PasswordRecovery";
import { useAuth } from "../lib/auth";
const brand = { name: "SANRU RH", logo: "/sanru-logo.jpg", loginUrl: "/" };
export function ForgotPasswordPage() { return <ForgotPasswordForm brand={brand} />; }
export function PasswordResetPage() { const { logout } = useAuth(); return <ResetPasswordForm brand={brand} onReset={logout} />; }
